

















































import BaseComponent from '@/components/base-component.vue';
import UiAutocompleteSubordinate from '@/components/UI/autocomplete-subordinate.vue';
import UiDatePickerRange from '@/components/UI/date-picker-range.vue';
import UiFilterContainer from '@/components/UI/filter-container.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import UiSelectSortOptions from '@/components/UI/select-sort-options.vue';
import { listCrmPlannerItemTypes } from '@/services/crm-planner';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({
  components: {
    PermissionAuth,
    UiFilterContainer,
    UiSelectSortOptions,
    UiDatePickerRange,
    UiAutocompleteSubordinate
  }
})
export default class PlannerFilters extends BaseComponent {
  @Prop()
  public menuMode?: boolean;

  filter: any = {};

  descending = false;
  sortBy = '';
  sortOptions = [];

  typesLoading = false;
  types = [];

  mounted() {
    this.buildSortOptions();
    this.loadTypes();
  }

  buildSortOptions() {
    this.descending = false;
    this.sortBy = null;
    this.sortOptions = [];
    this.sortOptions.push({ text: 'Data', value: 'dataIni' });
  }

  onSortChange(by, desc) {
    this.sortBy = by;
    this.descending = desc;
  }

  loadTypes() {
    this.typesLoading = true;
    listCrmPlannerItemTypes().subscribe(
      (res) => {
        this.typesLoading = false;
        this.types = res;
      },
      (error) => {
        this.typesLoading = false;
        this.showToastApiError(error);
      }
    );
  }

  onChangeFilter() {
    if (this.menuMode) {
      return;
    }

    this.emitFilter();
  }

  emitFilter() {
    if (this.menuMode) {
      this.filter.descending = this.descending;
      this.filter.sortBy = this.sortBy;
    } else {
      this.filter.sortBy = null;
    }
    this.$emit('filter', this.filter);
  }
}
